// ==============================|| OVERRIDES - ICON BUTTON ||============================== //

export default function IconButton(theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          '&.MuiIconButton-loading': {
            pointerEvents: 'none !important',
            '& svg': {
              width: 'inherit !important',
              height: 'inherit !important'
            }
          }
        },
        sizeLarge: {
          width: theme.spacing(5),
          height: theme.spacing(5),
          fontSize: '1.75rem'
        },
        sizeMedium: {
          width: theme.spacing(4),
          height: theme.spacing(4),
          fontSize: '1.4rem'
        },
        sizeSmall: {
          width: theme.spacing(3.25),
          height: theme.spacing(3.25),
          fontSize: '1.1rem'
        }
      }
    }
  };
}
